export enum SocialBattery {
  completely_drained = 'completely_drained',
  low = 'low',
  needs_recharge = 'needs_recharge',
  moderately_social = 'moderately_social',
  fully_charged = 'fully_charged',
  super_social = 'super_social',
}

export enum ComponentVisibility {
  PUBLIC = 'public',
  FRIENDS = 'friends',
  CLOSE_FRIENDS = 'close_friends',
  ONLY_ME = 'only_me',
}

export const DEFAULT_VISIBILITY = {
  song: ComponentVisibility.PUBLIC,
  mood: ComponentVisibility.FRIENDS,
  thought: ComponentVisibility.FRIENDS,
  battery: ComponentVisibility.FRIENDS,
};

export type CheckInBase = {
  id: number;
  is_active: boolean;
  created_at: string;
  mood: string[];
  social_battery: SocialBattery | null;
  thought: string;
  track_id: string;
  current_user_read: boolean;
  visibility?: string[];
  song_visibility?: ComponentVisibility;
  mood_visibility?: ComponentVisibility;
  thought_visibility?: ComponentVisibility;
  battery_visibility?: ComponentVisibility;
  battery_updated_at?: string;
  mood_updated_at?: string;
  song_updated_at?: string;
  thought_updated_at?: string;
  /** Optional opt-in auto-archive timestamp per component. Null / absent
   * means no archive — the component stays visible until the user clears it. */
  battery_archive_at?: string | null;
  mood_archive_at?: string | null;
  song_archive_at?: string | null;
  thought_archive_at?: string | null;
};

export type MyCheckIn = CheckInBase & {
  share_everyone: boolean;
  // FIXME: share_everyone, share_groups, share_friends의 타입 수정 필요
  share_groups: any[];
  shrare_friends: any[];
};

export type CheckInForm = Omit<
  CheckInBase,
  'id' | 'is_active' | 'created_at' | 'current_user_read'
>;
